// extracted by mini-css-extract-plugin
export default {"root":"PrimaryButton_root__v6cc+","loading":"PrimaryButton_loading__9Zawi"};